/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component } from 'react';
import { isPc } from './utils';
import pcStyles from './pc.less';
import mobileStyles from './mobile.less';
import classNames from 'classnames'

const styles = isPc() ? pcStyles : mobileStyles;

interface IContainerProps {
    /** presentController 样式类名 */
    presentControllerClassName?: string;
}

interface IContainerStates {
    isTranslucent: boolean;
}

export default class TencentMeetingLiveBar extends Component<IContainerProps, IContainerStates> {
    private domBarContainer: HTMLDivElement | null;
    private translucentTimer: ReturnType<typeof setTimeout> | null;
    private enter = false;
    constructor(props: IContainerProps) {
        super(props);
        this.state = {
            isTranslucent: true,
        };
        this.translucentTimer = null;
    }

    componentWillUnmount() {
        if (this.translucentTimer !== null) {
            clearTimeout(this.translucentTimer);
        }
    }

    setTranslucent = () => {
        this.setState({
            isTranslucent: false,
        });
    }

    startTranslucentTimer = (interval = 0) => {
        if (this.translucentTimer !== null) {
            clearTimeout(this.translucentTimer);
        }
        this.translucentTimer = setTimeout(() => {
            if (!this.enter) {
                this.setState({
                    isTranslucent: true,
                });
            }
        }, interval);
    }

    handleMouseEnter = () => {
        if (this.domBarContainer) this.domBarContainer.style.cursor = 'auto';
        this.setTranslucent();
        this.enter = true;
    }

    handleMouseLeave = () => {
        this.enter = false;
        this.startTranslucentTimer();
    }

    renderChildren = () => {
        const { children } = this.props;
        const nodes: React.ReactNode[] = [];
        React.Children.forEach(children, (child, index) => {
            if (child === null || child === undefined) return;

            // 此 wrapper 应该没必要存在，考虑到e2e先保留
            const item = <div className={styles.lineWrapper} key={`child_${index}`}>{child}</div>
            if (nodes.length > 0) nodes.push(<div key={`key_${index}`} className={styles.toolbarLine} />)

            nodes.push(item);
        });
        return nodes;
    }

    render() {
        const { presentControllerClassName } = this.props;
        const { isTranslucent } = this.state;
        return (
            <div className={classNames([styles.presentController, presentControllerClassName])}
                style={{ opacity: isTranslucent ? 0.5 : 1 }}
                onClick={(e) => { e.stopPropagation(); }}
                onMouseEnter={this.handleMouseEnter.bind(this)}
                onMouseLeave={this.handleMouseLeave.bind(this)}
            >
                {this.renderChildren()}
            </div>
        );
    }
}
